import { render, staticRenderFns } from "./SelectBinLocationFrom.vue?vue&type=template&id=6f4832e4&"
import script from "./SelectBinLocationFrom.vue?vue&type=script&lang=js&"
export * from "./SelectBinLocationFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports